import { render } from "./ClassScheduleList.vue?vue&type=template&id=509b63a3&scoped=true"
import script from "./ClassScheduleList.vue?vue&type=script&lang=js"
export * from "./ClassScheduleList.vue?vue&type=script&lang=js"

import "./ClassScheduleList.vue?vue&type=style&index=0&id=509b63a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509b63a3"]])

export default __exports__